/* 曹操傳・第 6 章：下邳水淹（建安三年，198）
 * 史實：《三國志·武帝紀》曹操東征呂布，圍下邳，「遂決泗、沂水以灌城。月餘，布將宋憲、魏續等執陳宮，舉城降」。
 * 流程：先擊退呂布的出城突擊 → 到上游把泗水、沂水的河堤掘開（站著讀條，守堤的兵會打斷）→
 *       水往低地漫，淹到城下；城中士氣隨著淹水一天天低落，呂布還會派人涉水出擊 → 士氣耗盡，宋憲、魏續執陳宮開城投降。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, PEOPLE, rout, vanish } from '../kit.ts';
import { CITY, GATE, DIKES, CAMP, HILLS } from '../maps/xiapi.ts';

const LV = 10;
const BU = { spec: TROOPS.dong, name: '呂布兵', hp: 460, maxHp: 460, atk: 28 };
const inHill = (x, y) => HILLS.some(([hx, hy, a, b]) => ((x - hx) / a) ** 2 + ((y - hy) / b) ** 2 < 1);

export default {
  id: 'caocao-6', map: 'xiapi', hero: 'caocao',
  title: '第 6 章　下邳水淹', year: '建安三年（198）',
  brief: {
    quote: [{ text: '遂決泗、沂水以灌城。月餘，布將宋憲、魏續等執陳宮，舉城降。', src: '《三國志·魏書·武帝紀》' }],
    text: '曹操東征呂布，連戰皆勝，把呂布圍在下邳。城堅難攻，士卒疲憊，荀攸、郭嘉勸曹操引泗水、沂水灌城。',
    goals: ['擊退呂布的出城突擊', '掘開泗水、沂水的河堤', '水淹下邳，等城中投降'],
  },
  words: { ally: '曹軍', foe: '呂布兵' },
  // 水會漫到的低地：河以南、曹營與西北高丘以外的地方
  lowland(m, x, y) { return y > 1150 && !inHill(x, y) && SG.MAP.walkable(x, y, 0) && !SG.MAP.waterAt(x, y); },
  stars: [
    { text: '60 秒內擊退呂布', ok: (m) => m.vars.repelT != null && m.vars.repelT < 60 },
    { text: '兩道河堤都在開戰後 3 分鐘內掘開', ok: (m) => m.vars.dikeT != null && m.vars.dikeT < 180 },
    { text: '曹軍折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
  ],
  steps: [
    { // 1. 擊退呂布
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 700; me.y = CAMP[1];
        V.t0 = w.t;
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 4) * 50, me.y - 60 + Math.floor(i / 4) * 90, '曹軍'); u.spec = TROOPS.wei; m.join(u, me); return u; });
        V.dun = ally(w, 'xiahoudun', me.x + 80, me.y - 100, LV);
        V.lb = boss(w, PEOPLE.lubu, GATE[0] - 300, GATE[1], { name: '呂布', hp: 4400, atk: 48, armor: 8, ms: 230 });
        V.lb.home = [me.x, me.y];
        V.sally = Array.from({ length: 8 }, (_, i) => { const u = m.foe('huangjin', GATE[0] - 300 - (i % 5) * 80, GATE[1] - 150 + Math.floor(i / 5) * 200, BU); u.home = [me.x + 200, me.y]; return u; });
        m.big('呂布出城了！');
        m.line('曹操', '呂布出城決戰——迎上去，把他打回城裡！');
        m.obj('repel', '擊退呂布的出城突擊');
        m.mark('lb', V.lb.x, V.lb.y, '呂布', false, V.lb);
      },
      tick(m, w) {
        const V = m.vars, lb = V.lb;
        if (lb.hp > lb.maxHp * 0.45) return false;
        V.repelT = w.t - V.t0;
        m.done('repel'); m.unmark('lb');
        lb.untargetable = true; lb.home = [CITY.x, CITY.y]; lb.target = null; m.line('呂布', '……先回城！');
        m.after(4, () => vanish(w, lb));
        rout(m, w, V.sally, [CITY.x, CITY.y]);
        m.gate('city', GATE[0], GATE[1], 190, 'citygate');
        return true;
      },
    },
    { // 2. 決泗、沂水
      enter(m, w) {
        const V = m.vars;
        m.line('曹操', '城堅難攻……荀攸、郭嘉說得對，引泗水、沂水來灌城！');
        V.dike = DIKES.map(([x, y], k) => { m.mark('d' + k, x, y + 100, k ? '沂水河堤' : '泗水河堤'); return { x, y, open: false, guard: Array.from({ length: 4 }, (_, i) => m.foe('huangjin', x - 120 + i * 80, y + 220, BU)) }; });
        m.obj('dike', '掘開泗水、沂水的河堤', 2);
        m.after(3, () => m.line('提示', '殺掉守堤的兵，站在河堤上不動就能掘開。水會往低地漫，曹營和西北的高丘淹不到。'));
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.dike.forEach((d, k) => {
          if (d.open) return;
          m.chanAt(me, 'd' + k, d.x, d.y + 100, 170, 3, '決堤', () => {
            d.open = true; m.unmark('d' + k); m.big(`${k ? '沂' : '泗'}水決堤！`);
            for (let i = -2; i <= 2; i++) m.flood(d.x + i * 80, d.y + 240);
          });
        });
        const n = V.dike.filter((d) => d.open).length;
        m.prog('dike', n);
        if (n < 2) return false;
        V.dikeT = w.t - V.t0;
        return true;
      },
    },
    { // 3. 灌城：等城中投降
      enter(m, w) {
        const V = m.vars;
        m.done('dike');
        m.card('遂決泗、沂水以灌城。', '《武帝紀》');
        m.after(3, () => m.line('曹操', '水漫過來了！全軍退回高地，等城裡撐不住。'));
        V.morale = 100;
        m.obj('morale', '');
        m.mark('hill', CAMP[0], CAMP[1], '高地');
        V.sallyT = 12;
      },
      tick(m, w, dt) {
        const V = m.vars;
        // 城下淹了多少：城牆外 900 內的水格
        let wet = 0;
        for (const c of m.fires.values()) if (c.water && Math.abs(c.x - CITY.x) < CITY.hw + 900 && Math.abs(c.y - CITY.y) < CITY.hh + 700) wet++;
        V.morale = Math.max(0, V.morale - dt * Math.min(4, wet / 25));
        m.get('morale').text = `城中的士氣：${Math.round(V.morale)}%（城下淹水 ${wet} 格）`;
        // 呂布派人涉水出擊
        V.sallyT -= dt;
        if (V.sallyT <= 0 && V.morale > 15) { V.sallyT = 14; for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', GATE[0] - 250, GATE[1] - 120 + i * 80, BU); u.home = [CAMP[0] + 600, CAMP[1]]; } m.line('呂布兵', '殺出去！'); }
        return V.morale <= 0;
      },
    },
    { // 4. 執陳宮，舉城降
      enter(m, w) {
        m.done('morale'); m.unmark('hill');
        m.ungate('city');
        m.card('布將宋憲、魏續等執陳宮，舉城降。', '《武帝紀》');
        rout(m, w, w.units.filter((u) => u.team === 1 && u.alive), [CITY.x, CITY.y]);
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('曹操陣亡'); return; }
    if (m.vars.dun) allyTick(w, m.vars.dun, w.player);
  },
};
